import { Injectable, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { getFullPath } from '../lib/get-full-path';
import { getTagFromEvent } from '../lib/get-tag-from-event';
import { smoothScroll } from '../lib/smooth-scroll';

@Injectable({
  providedIn: 'root',
})
export class InternalRouteHelperService {
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  public handleClick(event: Event) {
    const metaKey = (event as MouseEvent).metaKey;
    if (metaKey) return;

    const target = getTagFromEvent(event, 'A') as HTMLLinkElement;
    if (!target) return;
    const href = target.getAttribute('href');
    if (!href) return;

    event.preventDefault();
    if (this.isLocalLink(href)) {
      if (this.isAnchorLink(href)) {
        const id = this.getFragmentFromURL(href);
        return smoothScroll(event, id);
      } else {
        this.router.navigate([this.getPathFromURL(href)], {
          fragment: this.getFragmentFromURL(href),
          queryParams: this.getQueryFromURL(href),
        });
      }
    } else {
      window.open(target.href);
    }
  }

  private getPathFromURL(url: string) {
    const el = document.createElement('a');
    el.href = url;
    return el.pathname;
  }

  private getFragmentFromURL(url: string) {
    const el = document.createElement('a');
    el.href = url;
    return el.hash ? el.hash.substring(1) : undefined;
  }

  private getQueryFromURL(url: string) {
    const el = document.createElement('a');
    el.href = url;
    return Object.fromEntries(new URLSearchParams(el.search));
  }

  private isLocalLink(uri: string) {
    if (uri && (uri.startsWith('/') || uri.startsWith(location.origin) || uri.startsWith('#'))) {
      return true;
    } else {
      return false;
    }
  }

  private isAnchorLink(uri: string) {
    if (uri.startsWith('#')) return true;
    if (uri.startsWith(location.origin)) {
      uri = uri.replace(location.origin, '');
    }

    uri = uri.split('?')[0].split('#')[0];

    const currentPath = `/${getFullPath(this.route.snapshot).join('/')}`;
    return uri === currentPath;
  }
}
